import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getCompensatoryLeaves = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/CompensatoryLeave/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching compensatory leaves:", error);
    throw error;
  }
};

export const saveCompensatoryLeave = async (leave) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/CompensatoryLeave/save`, leave, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error saving compensatory leave:", error);
    throw error;
  }
}; 